import React from 'react'
import profilePic from '../img/creator_ravi.jpg'
import CodeGraph from './CodeGraph'

export default function About({ profileOnly = false }) {

    return (profileOnly)
        ? (
            <article className="media">
                <figure className="media-left">
                    <p className="image is-64x64">
                        <img src={profilePic} className="image is-64x64" alt="profile of Ravi Chandra Rachamalla" />
                    </p>
                </figure>
                <div className="media-content">
                    <div className="">
                        <p>
                            <strong>Ravi Rachamalla</strong> <small>@NullMainframe</small> | <small>January 1, 2020</small>
                            <br />
                            <span>
                                <span>
                                    Welcome to my Developer Portfolio, created in React as a Single Page Application. Take some time and click through the different
                                    sections. Updates will be coming soon.
                                    </span>
                                <span className="icon">
                                    <i className="fas fa-wrench"></i>
                                </span>

                            </span>

                        </p>
                    </div>
                </div>
            </article>
        )
        : (
            <div className="section About">
                <div className="tile is-ancestor">
                    <div className="tile is-6 is-horizontal is-parent">
                        {/* Section for the developer profile picture */}
                        <div className="tile is-child notification is-info has-text-centered is-flex is-flex-direction-column is-justify-content-center" id="header-image" style={{ borderBottomRightRadius: 'none', borderTopRightRadius: 'none' }}>
                            <h1 className="title">Ravi Rachamalla</h1>
                            <figure className="image is-4by5">
                                <img src={profilePic} className="rounded-corners" alt="profile of Ravi Chandra Rachamalla" />
                            </figure>
                        </div>

                        {/* Section for Developer Interests */}
                        <div className="tile is-child notification is-warning has-text-centered" id="header-dev">
                            <h1 className="title is-5">Top 5 Languages From Github</h1>
                            <div className="content">
                                <CodeGraph username="rach0022" />
                            </div>
                        </div>

                    </div>

                    {/* Section for Developer Description */}
                    <div className="tile is-parent">
                        <div className="tile is-child notification is-success has-text-centered">
                            <h1 className="title is-1">About Me</h1>
                            <p className="title">
                                I'm currently studying Mobile Application Design and Development at Algonquin College; graduating in the spring of 2021.
                            </p>
                            <a className="button is-danger" href="data/resume.docx">
                                <span className="icon">
                                    <i className="fas fa-file"></i>
                                </span>
                                <span>
                                    Resume
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        )
}
